/* Personalization Customizer */

import { KLCustomizer } from 'kl-customizer';

class KlPersonalizationCustomizer extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.formId = this.getAttribute('form-id');
    this.scope = KLCustomizer.scopeFrom(this);
    this.variantMap = JSON.parse(this.querySelector('[data-variant-map]')?.textContent || '{}');

    KLCustomizer.wireScope(this, this.scope, this.abortController.signal);
    this.#refresh();

    // Submit guard
    document.addEventListener('submit', (event) => {
      if (event.target === document.forms[this.formId]) this.#syncFormId();
    }, { capture: true, signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  onScopeChange(scope, event) {
    const input = event.target;

    if ('nativeOption' in input.dataset) {
      KLCustomizer.selectNativeOption(this.formId, input.value);
      this.#syncFormId();
    }

    this.#refresh();
  }

  #syncFormId() {
    const form = document.forms[this.formId];
    const key = Array.from(this.querySelectorAll('[data-native-option]:checked')).map((input) => input.dataset.optionValue).join('::');
    const variantId = this.variantMap[key];

    if (form && variantId && String(form.id.value) !== String(variantId)) {
      form.id.value = variantId;
    }
  }

  #refresh() {
    KLCustomizer.refresh(this.scope);

    const withPerso = KLCustomizer.withPerso(this.scope);
    this.querySelectorAll('[data-pattern], [data-font]').forEach((input) => (input.disabled = !withPerso));
  }
}

if (!window.customElements.get('kl-personalization-customizer')) {
  window.customElements.define('kl-personalization-customizer', KlPersonalizationCustomizer);
}
